module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_6000.336d1e7b.png";